module.exports = __webpack_public_path__ + "img/banner_02.f03a3262.jpg";